@if (apiLoaded$ | async) {
  @if (shouldShowMapButton$ | async) {
    <div class="h-full w-full flex flex-col items-center justify-center bg-gray-100 p-4">
      <div class="text-center mb-4">
        <i [class]="defaultIcon.GPSOff" class="text-6xl text-gray-500 mb-2"></i>
        <h3 class="text-lg font-semibold text-gray-700"> Map Disabled To Boost Performance </h3>
        <p class="text-sm text-gray-600 mt-1">
          {{ (totalPointCount$ | async) || 0 }} points detected (limit: {{ pointCountLimit }})
        </p>
      </div>
      <button
        (click)="showMap()"
        class="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-lg transition-colors"
      >
        Show Map
      </button>
    </div>
  } @else if (inputControl || (showPlaceHolder$ | async) === false) {
    <div #viewPort class="h-full w-full">
      <google-map #map [options]="(options$ | async) ?? {}" height="100%" width="100%">
        @if (point$ | async; as point) {
          <map-marker #point [position]="point.toLatLng()" [options]="pointOptions" />
        }
        @if (lclMapData$ | async) {
        }
        @if (lclOverlay$ | async; as htmlOverlays) {
          @for (htmlOverlay of htmlOverlays; track htmlOverlay) {
            <map-polygon [paths]="htmlOverlay.boundary" [options]="{ editable: true }" />
          }
        }
        <map-info-window #mapInfo>{{ infoContent }}</map-info-window>
      </google-map>
    </div>
  }
  @if (!inputControl && (showPlaceHolder$ | async)) {
    <div style="width: 300px; height: 300px; display: flex; background-color: #f5f8fa; justify-content: center">
      <i [class]="defaultIcon.GPSOff" class="text-4xl" style="display: flex; align-items: center"></i>
    </div>
  }
} @else {
  Loading...
}
